// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M5.70013 4.4428L12 1.92285L18.2999 4.4428L17.5571 6.29975L17 6.07692V7.99988H23V21.9999H13V15H11V21.9999H1V7.99988H7V6.07692L6.44291 6.29975L5.70013 4.4428ZM3 19.9999H7V9.99988H3V19.9999ZM17 9.99988V19.9999H21V9.99988H17ZM13.0039 6.99805H11V9.00195H13.0039V6.99805Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-14-filled')
export default class City14FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-14-filled',
    }
  }
}
